import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardText, CardTitle, FormGroup, Input, Spinner, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"
import relayEthAbi from "../../abi/RelayManagerETH.json"
import relayBscAbi from "../../abi/RelayManager2Secure.json"
import tokenIdoAbi from "../../abi/IDOToken.json"
import tokenWidoAbi from "../../abi/WIDO.json"
import tokenFidoAbi from "../../abi/FIDO.json"
import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import { formatNumber, avgGasPrice } from "../../utils"
import { useToast } from "../../hooks/toast"

import bscLogo from "../../assets/images/crypto/icons/binance.png"
import ethLogo from "../../assets/images/crypto/icons/ethereum.webp"
import ftmLogo from "../../assets/images/crypto/icons/fantom.png"
import maticLogo from "../../assets/images/crypto/icons/matic.webp"

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const subdomain = parts[0] // 'swordsofblood', 'localhost', 'app'

//should have a getRelayerInfo(subdomain) from subdomain.idexo.io
//populate info object for use
//when someone deploys relayers in the app and they have a subdomain, then it can store that info for retrieval, in relation to a chain

const whatRelayerInfoSubdomain = async (subdomain) => {
    if (subdomain === "bridge") {
        const info = {
            ethereum: {
                relayerAddress: "",
                relayerFee: "",
                tokenSymbol: "",
                tokenAddress: "",
                tokenAbi: ""
            },
            avalanche: {
                relayerAddress: "",
                relayerFee: "",
                tokenSymbol: "",
                tokenAddress: "",
                tokenAbi: ""
            },
            bsc: {
                relayerAddress: "",
                relayerFee: "",
                tokenSymbol: "",
                tokenAddress: "",
                tokenAbi: ""
            },
            fantom: {
                relayerAddress: "",
                relayerFee: "",
                tokenSymbol: "",
                tokenAddress: "",
                tokenAbi: ""
            }
        }
    } else {
        const info = {
            ethereum: {
                relayerAddress: "0x2e6f7e74490567a830ee133c4fd2038038a07989",
                relayerFee: "768",
                tokenSymbol: "IDO",
                tokenAddress: "0xf9c53268e9de692ae1b2ea5216e24e1c3ad7cb1e",
                tokenAbi: tokenIdoAbi
            },
            avalanche: {
                relayerAddress: "",
                relayerFee: "",
                tokenSymbol: "",
                tokenAddress: "",
                tokenAbi: ""
            },
            bsc: {
                relayerAddress: "0x8e8bc0890c5aba42a85dae1a524d0a169934a01d",
                relayerFee: "5",
                tokenSymbol: "WIDO",
                tokenAddress: "0x049EAb8A00E0600622883c8eBa4442bf23ac79A8",
                tokenAbi: tokenWidoAbi
            },
            fantom: {
                relayerAddress: "0xba94192eefe9b7a894d03c209fc8292bd53dfdc2",
                relayerFee: "5",
                tokenSymbol: "FIDO",
                tokenAddress: "0x7aa1d538bc7b8f756179d37fb92dc0435fb71ab1",
                tokenAbi: tokenFidoAbi
            }
        }
    }
}

const Bridge = () => {
    const data = {
        ethereum: {
            chainId: 1,
            providerUri: `https://mainnet.infura.io/v3/4363ee00139541a08755dd2408c2e62a`, // TODO: change to idexo api key
            explorer: "https://etherscan.io/tx/",
            gas: { approve: 65000, deposit: 100000 },
            chainName: "Ethereum",
            value: "ethereum",
            chainSymbol: "ETH",
            logo: ethLogo,
            relayerAddress: "0x2e6f7e74490567a830ee133c4fd2038038a07989",
            relayerAbi: relayEthAbi,
            relayerFee: 768,
            tokenSymbol: "IDO",
            tokenAddress: "0xf9c53268e9de692ae1b2ea5216e24e1c3ad7cb1e",
            tokenAbi: tokenIdoAbi
        },
        bsc: {
            chainId: 56,
            providerUri: "https://bsc-dataseed.binance.org",
            explorer: "https://bscscan.com/tx/",
            gas: { approve: 300000, deposit: 300000 },
            chainName: "Binance Smart Chain",
            value: "bsc",
            chainSymbol: "BSC",
            logo: bscLogo,
            relayerAddress: "0x8e8bc0890c5aba42a85dae1a524d0a169934a01d",
            relayerAbi: relayBscAbi,
            relayerFee: 5,
            tokenSymbol: "WIDO",
            tokenAddress: "0x049EAb8A00E0600622883c8eBa4442bf23ac79A8",
            tokenAbi: tokenWidoAbi
        },
        fantom: {
            chainId: 250,
            providerUri: "https://rpc.ftm.tools", // change this
            explorer: "https://ftmscan.com/tx/",
            gas: { approve: 300000, deposit: 300000 },
            chainName: "Fantom",
            value: "fantom",
            chainSymbol: "FTM",
            logo: ftmLogo,
            relayerAddress: "0xba94192eefe9b7a894d03c209fc8292bd53dfdc2",
            relayerAbi: relayBscAbi, // TODO: change to correct contract
            relayerFee: 5,
            tokenSymbol: "FIDO",
            tokenAddress: "0x7aa1d538bc7b8f756179d37fb92dc0435fb71ab1",
            tokenAbi: tokenFidoAbi
        },
        polygon: {
            chainId: 137,
            providerUri: "https://rpc.ankr.com/polygon", // change this
            explorer: "https://polygonscan.com/tx/",
            gas: { approve: 300000, deposit: 300000 },
            chainName: "Polygon",
            value: "polygon",
            chainSymbol: "MATIC",
            logo: maticLogo,
            relayerAddress: "0x43B1803a120a8a8d0cC82e5Edd813d98dbc06BA1",
            relayerAbi: relayEthAbi, // TODO: change to correct contract
            relayerFee: 5,
            tokenSymbol: "TEST",
            tokenAddress: "0xcfb8bdf086854b05e9c3144c27db57bef83186b0",
            tokenAbi: tokenFidoAbi
        }
    }

    const [from, setFrom] = useState(data.ethereum)
    const [to, setTo] = useState(data.fantom)

    const [fromOptions, setFromOptions] = useState([data.ethereum, data.bsc, data.fantom, data.polygon])
    const [toOptions, setToOptions] = useState([data.bsc, data.fantom])

    const [amount, setAmount] = useState("0")

    const [fromBalance, setFromBalance] = useState(0)
    const [toBalance, setToBalance] = useState(0)
    const [fromAllowance, setFromAllowance] = useState(0)

    const web3 = new Web3(window.ethereum)

    const [isLoading, setIsLoading] = useState(false)
    const [processingApprove, setProcessingApprove] = useState(false)
    const [processingDeposit, setProcessingDeposit] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)

    const [txModal, setTxModal] = useState(false)
    const [tx, setTx] = useState({
        status: "",
        hash: ""
    })

    const handleTx = (status, hash) => {
        setTx({ status: status, hash: hash })
    }

    const handleTxModal = (type) => {
        switch (type) {
            case "open":
                setTxModal(true)
                break
            case "close":
                setTxModal(false)
                setTx("", "")
                break

            default:
                break
        }
    }

    const [chainId, setChainId] = useState(undefined)
    const [account, setAccount] = useState(0)

    const toast = useToast()
    const wallet = useWallet()

    const minTransferAmount = 5 //TODO: GET FROM CONTRACT

    const handleInputAmount = (e) => {
        const value = parseFloat(e.target.value || 0)
        setAmount(value)
    }

    const handleSubmitButton = async (action, type) => {
        switch (action) {
            case "approve":
                if (from.value === "ropsten") {
                    await approveFunction(from, fromBalance, amount)
                }
                if (from.value === "ethereum") {
                    await approveFunction(from, fromBalance, amount)
                }
                if (from.value === "bsc") {
                    await approveFunction(from, fromBalance, amount)
                }
                if (from.value === "fantom") {
                    await approveFunction(from, fromBalance, amount)
                }
                if (from.value === "polygon") {
                    await approveFunction(from, fromBalance, amount)
                }
                break

            case "deposit":
                if (from.value === "ropsten") {
                    await depositFunction(from, to, fromBalance, amount)
                    setAmount(0)
                }
                if (from.value === "ethereum") {
                    await depositFunction(from, to, fromBalance, amount)
                    setAmount(0)
                }
                if (from.value === "bsc") {
                    await depositFunction(from, to, fromBalance, amount)
                    setAmount(0)
                }
                if (from.value === "fantom") {
                    await depositFunction(from, to, fromBalance, amount)
                }
                if (from.value === "polygon") {
                    await depositFunction(from, to, fromBalance, amount)
                }
                break

            default:
                break
        }
    }

    const filterToOptions = (obj, from) => {
        const array = Object.entries(obj)
        const filteredArray = array.filter(function ([key, value]) {
            return key !== from
        })
        const result = filteredArray.map((item) => item[1])
        setToOptions(result)
        return result
    }

    const handleSelect = (e, type) => {
        setAmount(0)
        const value = e.target.value

        switch (type) {
            case "from":
                filterToOptions(data, value)
                if (value === "ropsten") {
                    setFrom(data.ropsten)
                    setTo(data.bsc)
                } else if (value === "ethereum") {
                    setFrom(data.ethereum)
                    setTo(data.fantom)
                } else if (value === "bsc") {
                    setFrom(data.bsc)
                    setTo(data.fantom)
                } else if (value === "fantom") {
                    setFrom(data.fantom)
                    setTo(data.ethereum)
                } else if (value === "polygon") {
                    setFrom(data.polygon)
                    setTo(data.fantom)
                }
                break
            case "to":
                if (value === "ropsten") {
                    setFrom(data.ropsten)
                    setTo(data.fantom)
                } else if (value === "ethereum") {
                    setTo(data.ethereum)
                } else if (value === "bsc") {
                    setTo(data.bsc)
                } else if (value === "fantom") {
                    setTo(data.fantom)
                }
                break

            default:
                break
        }
    }

    const makeTransactObj = async (from, address, gas) => {
        if (from === "ethereum") {
            // console.log(`type 2 tx`)
            return {
                from: address,
                gas,
                // gasPrice: maxFeePerGas,
                type: "0x2",
                maxFeePerGas: (await avgGasPrice()) * 10, // maxFeePerGas = baseFeePerGas + maxPriorityFeePerGas
                maxPriorityFeePerGas: 1500000000 // like a "tip" to miner
            }
        } else {
            // console.log(`type 1 tx`)
            return {
                from: address,
                gas: gas
                // gasPrice: await avgGasPrice()
            }
        }
    }

    const approveFunction = async (from, fromBalance, amount) => {
        if (chainId === from.chainId) {
            if (amount <= fromBalance) {
                setProcessingApprove(true)
                try {
                    let tokenContract = new web3.eth.Contract(from.tokenAbi, from.tokenAddress)

                    let approveAmount = web3.utils.toWei((10000000).toString())
                    let allowance = await tokenContract.methods.allowance(wallet.account, from.relayerAddress).call()

                    if (amount >= minTransferAmount) {
                        if (allowance < approveAmount) {
                            await tokenContract.methods
                                .approve(from.relayerAddress, approveAmount)
                                .send(await makeTransactObj(from.value, wallet.account, from.gas.approve)) // TODO: Set gas rates according to fromChainId
                                .on("transactionHash", function (hash) {
                                    // console.log(hash)
                                    handleTx("processing", hash)
                                    handleTxModal("open")
                                })
                                .on("receipt", function (receipt) {
                                    console.log(receipt)
                                    if (receipt.status === true) {
                                        setFromAllowance(amount)
                                        setProcessingApprove(false)
                                        handleTx("done", receipt.transactionHash)
                                        toast.addSuccess(`${amount} ${from.tokenSymbol} successfully approved.`)
                                    } else {
                                        handleTx("error", receipt?.transactionHash)
                                        toast.addError("Approve Fail")
                                        setProcessingApprove(false)
                                    }
                                })
                                .on("error", function (error) {
                                    toast.addError(error.message)
                                    setProcessingApprove(false)
                                })
                        }
                    }
                    // provider.engine.stop()
                } catch (error) {
                    setProcessingApprove(false)
                    console.log(error)
                }
            } else {
                toast.addInfo("Amount must be equal to or less than balance!")
            }
            setProcessingApprove(false)
        } else {
            toast.addInfo(`Select the ${from.chainName} network in your Metamask!`)
        }
        setProcessingApprove(false)
    }

    const depositFunction = async (from, to, fromBalance, amount) => {
        if (chainId === from.chainId) {
            if (amount <= fromBalance) {
                setProcessingDeposit(true)
                try {
                    let relayContract = new web3.eth.Contract(from.relayerAbi, from.relayerAddress)

                    let depositAmount = web3.utils.toWei(amount.toString())

                    if (amount >= minTransferAmount) {
                        await relayContract.methods
                            .deposit(wallet.account, depositAmount, to.chainId)
                            .send(await makeTransactObj(from.value, wallet.account, from.gas.deposit))
                            .on("transactionHash", function (hash) {
                                console.log(hash)
                                handleTx("processing", hash)
                                handleTxModal("open")
                            })
                            .on("receipt", function (receipt) {
                                console.log(receipt)
                                if (receipt.status === true) {
                                    setProcessingDeposit(false)
                                    handleTx("done", receipt.transactionHash)
                                    toast.addSuccess(`${amount} ${from.tokenSymbol} successfully deposited.`)
                                } else {
                                    toast.addError("Deposit Fail")
                                    handleTx("error", receipt?.transactionHash)
                                    setProcessingDeposit(false)
                                }
                            })
                            .on("error", function (error) {
                                setProcessingDeposit(false)
                                toast.addError(error.message)
                            })
                    }
                } catch (error) {
                    setProcessingDeposit(false)
                    console.log(error)
                }
            } else {
                toast.addInfo("Amount must be equal to or less than balance!")
            }
            setProcessingDeposit(false)
        } else {
            toast.addInfo(`Select the ${from.chainName} network in your Metamask!`)
        }
        setProcessingDeposit(false)
    }

    useEffect(() => {
        async function getDetails() {
            if (wallet.account) {
                setIsLoading(true)
                setFromBalance(0)
                setToBalance(0)
                try {
                    let fromProviderUri = from.providerUri
                    let fromTokenAddress = from.tokenAddress
                    let fromTokenAbi = from.tokenAbi
                    let fromRelayerAddress = from.relayerAddress
                    let toTokenAddress = to.tokenAddress
                    let toProviderUri = to.providerUri
                    let toTokenAbi = to.tokenAbi

                    let fromWeb3 = new Web3(fromProviderUri)

                    let toWeb3 = new Web3(toProviderUri)

                    let fromTokenContract = new fromWeb3.eth.Contract(fromTokenAbi, fromTokenAddress)

                    let toTokenContract = new toWeb3.eth.Contract(toTokenAbi, toTokenAddress)

                    let fromBalance = await fromTokenContract.methods.balanceOf(wallet.account).call()
                    let fromAllowed = await fromTokenContract.methods.allowance(wallet.account, fromRelayerAddress).call()

                    let toBalance = await toTokenContract.methods.balanceOf(wallet.account).call()

                    setFromBalance(web3.utils.fromWei(fromBalance, "ether"))
                    setToBalance(web3.utils.fromWei(toBalance, "ether"))

                    setFromAllowance(web3.utils.fromWei(fromAllowed, "ether"))

                    setIsLoading(false)
                } catch (error) {
                    console.log("Unable to get balances!")
                    console.log(error)
                    setIsLoading(false)
                }
            }
        }
        getDetails()
        return () => {
            // cleanup
        }
    }, [from, to, wallet.account])

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                    setChainId(wallet.chainId)
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    const disabledInputAmount = () => {
        if (processingDeposit || processingApprove) return true
        return false
    }

    const disabledApproveButton = () => {
        if (isNaN(amount) || amount <= to.relayerFee || amount === 0 || amount > fromBalance || processingApprove) return true
        return false
    }

    const disabledTransferButton = () => {
        if (isNaN(amount) || fromAllowance < amount || amount <= to.relayerFee || amount === 0 || amount > fromBalance || processingDeposit)
            return true
        return false
    }

    return (
        <React.Fragment>
            <div className="content bridge-page">
                <BreadCrumb items={["Bridge"]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} onChange={() => setIsConnectedToWallet(wallet.status === "connected")} />
                ) : (
                    <div className="bridge-body">
                        <Card>
                            <CardBody>
                                <CardTitle className="h3">
                                    From {from.chainSymbol} ({from.tokenSymbol}) To {to.chainSymbol} ({to.tokenSymbol}) Bridge
                                </CardTitle>
                                <div className="align-items-center your-details row-wrap">
                                    <div className="transfer-wrap">
                                        <div className="bridge-bg d-flex flex-wrap align-items-center justify-content-between right">
                                            <div className="bridge-bg-right chain-direction">
                                                <FormGroup>
                                                    {/* <CardText className="card-text-label text-uppercase">From</CardText> */}
                                                    <div className="select-balance">
                                                        <CardText className="card-text-label text-uppercase">
                                                            Balance:{" "}
                                                            {isLoading ? (
                                                                <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                                                            ) : (
                                                                <span className="amount-value">
                                                                    {formatNumber(fromBalance, 5)} {from.tokenSymbol}
                                                                </span>
                                                            )}
                                                        </CardText>
                                                    </div>
                                                    <div className="select-component">
                                                        <div className="bridge-logo">
                                                            <img src={from.logo} alt={from.chainSymbol} />
                                                        </div>

                                                        <Input
                                                            disabled={false}
                                                            type="select"
                                                            value={from.value}
                                                            style={{ textAlign: "center" }}
                                                            onChange={(e) => handleSelect(e, "from")}
                                                            className="form-control w-100"
                                                        >
                                                            {fromOptions.map((option) => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.chainName}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </div>
                                                    <div className="bridge-direction">
                                                        <i className="bx bx-down-arrow-alt"></i>
                                                    </div>
                                                    {/* <CardText className="card-text-label text-uppercase">To</CardText> */}
                                                    <div className="select-balance">
                                                        <CardText className="card-text-label text-uppercase">
                                                            Balance:{" "}
                                                            {isLoading ? (
                                                                <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                                                            ) : (
                                                                <span className="amount-value">
                                                                    {formatNumber(toBalance, 5)} {to.tokenSymbol}
                                                                </span>
                                                            )}
                                                        </CardText>
                                                    </div>
                                                    <div className="select-component">
                                                        <div className="bridge-logo">
                                                            <img src={to.logo} alt={to.chainSymbol} />
                                                        </div>

                                                        <Input
                                                            disabled={false}
                                                            type="select"
                                                            value={to.value}
                                                            style={{ textAlign: "center" }}
                                                            onChange={(e) => handleSelect(e, "to")}
                                                            className="form-control w-100"
                                                        >
                                                            {toOptions.map((option) => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.chainName}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </div>
                                                </FormGroup>
                                            </div>
                                        </div>

                                        <div className="bridge-bg bridge-ido right">
                                            <div className="flex-wrap align-items-center justify-content-between">
                                                <div className="bridge-bg-right">
                                                    <FormGroup>
                                                        <div className="select-balance">
                                                            <CardText className="card-text-label text-uppercase">
                                                                {isLoading ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                                                                ) : (
                                                                    <span
                                                                        className="amount-value"
                                                                        onClick={() => {
                                                                            setAmount(parseFloat(fromBalance))
                                                                        }}
                                                                    >
                                                                        max
                                                                    </span>
                                                                )}
                                                            </CardText>
                                                        </div>
                                                        <div className="amount-input">
                                                            <CardText className="card-text-label text-uppercase">Amount: </CardText>
                                                            <Input
                                                                type="number"
                                                                onFocus={(e) => e.target.select()}
                                                                className="form-control w-100"
                                                                style={{ textAlign: "right" }}
                                                                onChange={(e) => handleInputAmount(e)}
                                                                value={amount}
                                                                disabled={disabledInputAmount()}
                                                            ></Input>
                                                        </div>
                                                        {fromAllowance < amount && !(amount < to.relayerFee) && !(amount > fromBalance) ? (
                                                            <Button
                                                                className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                onClick={() => handleSubmitButton("approve")}
                                                                style={{ width: "100%" }}
                                                                disabled={disabledApproveButton()}
                                                            >
                                                                {chainId !== from.chainId
                                                                    ? `Change to ${from.value} in your wallet`
                                                                    : amount > fromBalance
                                                                      ? "Insufficient balance!"
                                                                      : !processingApprove
                                                                        ? "Approve TOKEN"
                                                                        : "Processing... "}
                                                                {processingApprove ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                className="btn submit-btn w-100 blue-btn text-uppercase"
                                                                onClick={() => handleSubmitButton("deposit")}
                                                                style={{ width: "100%" }}
                                                                disabled={disabledTransferButton()}
                                                            >
                                                                {chainId !== from.chainId
                                                                    ? `Change to ${from.value} in your wallet`
                                                                    : amount > fromBalance
                                                                      ? "Insufficient balance!"
                                                                      : !processingDeposit
                                                                        ? "Transfer"
                                                                        : "Processing... "}
                                                                {processingDeposit ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        )}
                                                        {amount - to.relayerFee > 0 && amount > 0 ? (
                                                            <CardText className="card-text-label text-uppercase mt-2">
                                                                You will receive: {amount - to.relayerFee}
                                                            </CardText>
                                                        ) : amount > 0 ? (
                                                            <CardText className="card-text-label text-uppercase text-danger mt-2">
                                                                (Amount - Admin Fee) must be greater than "0"
                                                            </CardText>
                                                        ) : null}
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bridge-bg bridge-ido right">
                                            <div className="flex-wrap align-items-center justify-content-between">
                                                <div className="bridge-bg-right">
                                                    <CardText className="card-text-label text-uppercase">Bridge Fees</CardText>
                                                    <div className="bridge-bg-right tokens">
                                                        <Table borderless>
                                                            <tbody>
                                                                <tr className="your-details-table-row">
                                                                    <td>
                                                                        {from.chainSymbol} to {to.chainSymbol}:{" "}
                                                                    </td>
                                                                    <td>
                                                                        {to.relayerFee} {from.tokenSymbol}
                                                                    </td>
                                                                </tr>
                                                                <tr className="your-details-table-row">
                                                                    <td>
                                                                        {to.chainSymbol} to {from.chainSymbol}:{" "}
                                                                    </td>
                                                                    <td>
                                                                        {from.relayerFee} {to.tokenSymbol}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Modal isOpen={txModal} fade={true} centered={true}>
                            <ModalHeader className="title-center">Transaction details</ModalHeader>
                            <ModalBody>
                                {tx.status === "processing"
                                    ? "Your transaction is being processed..."
                                    : tx.status === "done"
                                      ? "✅ Your transaction has been processed"
                                      : tx.status === "error"
                                        ? "❌ Your transaction failed"
                                        : "❓ No transaction information"}
                            </ModalBody>
                            <ModalBody>
                                <a href={from.explorer + tx.hash} target="_blank" rel="noopener noreferrer">
                                    View in explorer
                                </a>
                            </ModalBody>
                            <ModalFooter className="text-center">
                                <Button
                                    onClick={() => {
                                        handleTxModal("close")
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default Bridge
